<script lang="ts" setup>
import FiduciarydutyTemplate from '~/components/templates/_lp/FiduciarydutyTemplate/FiduciarydutyTemplate.vue';

useAppMeta({
  title: 'フィデューシャリーデューティー宣言',
});
</script>

<template>
  <FiduciarydutyTemplate />
</template>
